// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard-upload .modal-outer.opened {
    display: flex;
    justify-content: center;
    align-items: center;
}

.leaderboard-upload .modal-content {
    position: relative;
}

.leaderboard-upload .loader {
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
}

.leaderboard-upload .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.leaderboard-upload .warning-message {
    margin-top: 7px;
}`, "",{"version":3,"sources":["webpack://./client/components/dashboard/dynamicWebview/common/UploadModal/uploadModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gCAAgC;IAChC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".leaderboard-upload .modal-outer.opened {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.leaderboard-upload .modal-content {\n    position: relative;\n}\n\n.leaderboard-upload .loader {\n    position: absolute;\n    top: 50%;\n    right: 50%;\n    transform: translate(-50%, -50%);\n    width: 30px;\n    height: 30px;\n}\n\n.leaderboard-upload .footer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.leaderboard-upload .warning-message {\n    margin-top: 7px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
